import { useEffect, useRef } from "react";

/**
 * When a DPAT assessment has started, indicators must read the CMS snapshot only.
 * Before start, they load live DHIS2 data.
 */
export function useDpatIndicatorDataSource({
  isAssessmentStarted,
  savedAssessmentData,
  assessmentStartLoading,
  loadFromDhis2,
  applySnapshot,
  deps = [],
}) {
  const loadRef = useRef(loadFromDhis2);
  const applyRef = useRef(applySnapshot);
  loadRef.current = loadFromDhis2;
  applyRef.current = applySnapshot;

  useEffect(() => {
    if (isAssessmentStarted) {
      if (savedAssessmentData && applyRef.current) {
        applyRef.current(savedAssessmentData);
      }
      return;
    }
    loadRef.current?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAssessmentStarted, savedAssessmentData, assessmentStartLoading, ...deps]);

  return {
    useCmsSnapshot: Boolean(isAssessmentStarted),
    loading: Boolean(isAssessmentStarted && assessmentStartLoading),
  };
}
